import { PawPrint } from 'lucide-react'
import { tint } from '@/lib/paper'
import { portraitUrl } from '@/lib/tree'
import { cn } from '@/lib/utils'

// A person's face in a circle: their portrait, or their initial on a tint when there isn't one yet (a paw print for
// a pet).
export function Avatar({
  person,
  className,
  variant = 'thumb',
}: {
  person: { id: string; name: string; portrait: string | null; pet?: boolean }
  className?: string
  variant?: 'thumb' | 'display'
}) {
  const index = [...person.id].reduce((n, ch) => n + ch.charCodeAt(0), 0)
  return (
    <span
      aria-hidden="true"
      className={cn(
        'grid shrink-0 place-items-center overflow-hidden rounded-full font-semibold text-foreground shadow-paper',
        tint(index),
        className,
      )}
    >
      {person.portrait ? (
        <img src={portraitUrl(person.portrait, variant)} alt="" decoding="async" className="size-full object-cover" />
      ) : person.pet ? (
        <PawPrint className="size-[45%]" strokeWidth={1.75} />
      ) : (
        person.name.trim().charAt(0).toUpperCase()
      )}
    </span>
  )
}
